<template lang="pug">
v-container(fluid='')
      v-card
        v-card-title.d-flex.justify-space-between
          span Gesti&oacute;n de Restaurantes
          v-btn(color='primary', @click='openDialog()')
            v-icon(left='') mdi-plus
            |  Nuevo Restaurante
        v-card-text
          // Search and filters
          v-row.mb-4
            v-col(cols='12', sm='6', md='4')
              v-text-field(v-model='search', label='Buscar restaurante', prepend-inner-icon='mdi-magnify', outlined='', dense='', clearable='')
            v-col(cols='12', sm='6', md='4')
              v-select(v-model='brandFilter', :items='brands', item-text='name', item-value='_id', label='Filtrar por marca', outlined='', dense='', clearable='')
            v-col(cols='12', sm='6', md='4')
              v-select(v-model='statusFilter', :items='statusOptions', label='Estado', outlined='', dense='', clearable='')
          // Restaurants table
          v-data-table(:headers='headers', :items='filteredRestaurants', :loading='loading', :search='search')
            template(v-slot:item.logo='{ item }')
              v-avatar(size='40')
                v-img(:src='item.logo', :alt='item.name')
            template(v-slot:item.brand='{ item }')
              | {{ item.brand?.name }}
            template(v-slot:item.isActive='{ item }')
              v-chip(
                :color="item.isActive ? 'success' : 'error'"
                :text-color="'white'"
                small
                label
              )
                v-icon(left small) {{ item.isActive ? 'mdi-check-circle' : 'mdi-close-circle' }}
                | {{ item.isActive ? 'Activo' : 'Inactivo' }}
            template(v-slot:item.actions='{ item }')
              v-btn(icon small class="mr-2" @click="openDialog(item)")
                v-icon mdi-pencil
              v-btn(icon small color="warning" @click="confirmDeactivate(item)" v-if="item.isActive")
                v-icon mdi-archive
              v-btn(icon small color="success" @click="confirmReactivate(item)" v-else)
                v-icon mdi-archive-arrow-up
              v-btn.mr-2(icon='', small='', @click='openUsersDialog(item)')
                v-icon mdi-account-group
      // Diálogo de gestión de usuarios
      v-dialog(v-model='usersDialog', max-width='1200')
        v-card
          v-card-title.d-flex.justify-space-between
            span Usuarios de {{ selectedRestaurant?.name }}
            v-btn(color='primary', @click='openUserForm()')
              v-icon(left) mdi-plus
              | Nuevo Usuario
          v-card-text
            v-data-table(
              :headers='userHeaders',
              :items='restaurantUsers',
              :loading='loadingUsers',
              no-data-text='No hay usuarios registrados'
            )
              template(v-slot:item.photo='{ item }')
                v-avatar(size='32')
                  v-img(v-if='item.photo', :src='item.photo', :alt='item.name')
                  v-icon(v-else) mdi-account
              template(v-slot:item.role='{ item }')
                v-chip(
                  :color='getRoleColor(item.role?.name)',
                  small,
                  text-color='white'
                )
                  | {{ item.role?.name || 'Sin rol' }}
              template(v-slot:item.active='{ item }')
                v-chip(
                  :color='item.active ? "success" : "error"',
                  small,
                  text-color='white'
                )
                  v-icon(left, small) {{ item.active ? 'mdi-check' : 'mdi-close' }}
                  | {{ item.active ? 'Activo' : 'Inactivo' }}
              template(v-slot:item.actions='{ item }')
                v-btn(icon, small, @click='openUserForm(item)')
                  v-icon mdi-pencil
                v-btn(
                  icon,
                  small,
                  :color='item.active ? "warning" : "success"',
                  @click='toggleUserStatus(item)'
                )
                  v-icon {{ item.active ? 'mdi-account-off' : 'mdi-account-check' }}
          v-card-actions
            v-spacer
            v-btn(text, @click='closeUsersDialog') Cerrar
      
      // Diálogo de formulario de usuario
      v-dialog(v-model='userFormDialog', max-width='600')
        v-card
          v-card-title
            | {{ editedUser._id ? 'Editar Usuario' : 'Nuevo Usuario' }}
          v-card-text
            v-form(ref='userForm', v-model='userFormValid')
              v-row
                v-col(cols='12', sm='6')
                  v-text-field(
                    v-model='editedUser.name',
                    label='Nombre completo',
                    :rules='nameRules',
                    required
                  )
                v-col(cols='12', sm='6')
                  v-text-field(
                    v-model='editedUser.email',
                    label='Email',
                    :rules='emailRules',
                    required
                  )
                v-col(cols='12', sm='6')
                  v-text-field(
                    v-model='editedUser.phone',
                    label='Teléfono',
                    :rules='phoneRules'
                  )
                v-col(cols='12', sm='6')
                  v-text-field(
                    v-model='editedUser.dni',
                    label='DNI'
                  )
                v-col(cols='12', sm='6')
                  v-select(
                    v-model='editedUser.role',
                    :items='availableRoles',
                    item-text='name',
                    item-value='_id',
                    label='Rol',
                    :rules='[v => !!v || "El rol es requerido"]',
                    required
                  )
                v-col(cols='12', sm='6', v-if='!editedUser._id')
                  v-text-field(
                    v-model='editedUser.password',
                    label='Contraseña',
                    type='password',
                    :rules='passwordRules',
                    required
                  )
                v-col(cols='12', sm='6', v-if='editedUser._id')
                  v-text-field(
                    v-model='editedUser.password',
                    label='Nueva contraseña (opcional)',
                    type='password',
                    hint='Dejar vacío para mantener la actual'
                  )
                v-col(cols='12')
                  v-switch(
                    v-model='editedUser.active',
                    label='Usuario activo',
                    color='success'
                  )
          v-card-actions
            v-spacer
            v-btn(text, @click='closeUserForm') Cancelar
            v-btn(
              color='primary',
              :disabled='!userFormValid',
              :loading='savingUser',
              @click='saveUser'
            ) {{ editedUser._id ? 'Actualizar' : 'Crear' }}
      // Restaurant Dialog
      v-dialog(v-model='dialog', max-width='800')
        v-card
          v-card-title
            | {{ editedItem._id ? &apos; Editar&apos; : &apos;Nuevo&apos; }} Restaurante
          v-card-text
            v-form(ref='form', v-model='valid')
              v-row
                v-col(cols='12', sm='6')
                  v-text-field(v-model='editedItem.name', label='Nombre', :rules='nameRules', required='')
                v-col(cols='12', sm='6')
                  v-select(v-model='editedItem.brand', :items='brands', item-text='name', item-value='_id', label='Marca',)
                v-col(cols='12')
                  v-textarea(
                    v-model='editedItem.description'
                    label='Descripción'
                    :rules='[v => !!v || "La descripción es requerida"]'
                    required=''
                    auto-grow
                    rows='3'
                    counter='500'
                  )
                v-col(cols='12')
                  v-card(outlined='')
                    v-card-text
                      .d-flex.justify-space-between.align-center
                        div
                          .subtitle-1.font-weight-bold Ubicación
                          .caption(v-if='editedItem.location?.address')
                            | {{ editedItem.location.address }}
                            .caption.grey--text.mt-1
                              | {{ editedItem.location.city }}, {{ editedItem.location.province }}
                          .caption.grey--text(v-else='') No configurada
                        v-btn(color='primary', @click='locationDialog = true')
                          | {{ editedItem.location && editedItem.location.address ? 'Editar' : 'Configurar' }}
                v-col(cols='12', sm='6')
                  v-select(
                    v-model='editedItem.categories', 
                    :items='restaurantCategories', 
                    item-text='name', 
                    item-value='_id', 
                    label='Categorías (máximo 2)', 
                    multiple
                    :rules="[v => !v || v.length <= 2 || 'Máximo 2 categorías']"
                    chips
                    deletable-chips
                  )
                v-col(cols='12', sm='6')
                  v-text-field(v-model='editedItem.phone', label='Teléfono', :rules='phoneRules')
                v-col(cols='12', sm='6')
                  v-img.grey.lighten-2.mb-4(v-if='editedItem.logo', :src='editedItem.logo', max-height='200', contain='')
                  v-file-input(v-model='logoFile', label='Logo', accept='image/*', :rules='logoRules', @change='handleLogoUpload', show-size='', prepend-icon='mdi-camera')
                v-col(cols='12', sm='6')
                  v-switch(v-model='editedItem.isActive', label='Activo', color='success')
          v-card-actions
            v-spacer
              v-btn(text='', @click='closeDialog') Cancelar
              v-btn(color='primary', :disabled='!valid', @click='save')  Guardar
      location-dialog(
        v-model='locationDialog',
        :initial-location='getLocationForDialog()',
        @save='updateLocation'
      )
      // Deactivate Confirmation
      v-dialog(v-model='deactivateDialog', max-width='500')
        v-card
          v-card-title {{ restaurantToDeactivate?.isActive ? '¿Desactivar Restaurante?' : '¿Reactivar Restaurante?' }}
          v-card-text
            div(v-if="restaurantToDeactivate?.isActive")
              p ¿Estás seguro de que deseas desactivar el restaurante "{{ restaurantToDeactivate?.name }}"?
              p.caption.grey--text El restaurante no será visible para los clientes, pero se conservarán todos los datos históricos.
              v-textarea(
                v-model="deactivationReason"
                label="Razón de desactivación (opcional)"
                rows="2"
                outlined
                dense
              )
            div(v-else)
              p ¿Estás seguro de que deseas reactivar el restaurante "{{ restaurantToDeactivate?.name }}"?
              p.caption.grey--text El restaurante volverá a ser visible para los clientes.
          v-card-actions
            v-spacer
              v-btn(text='', @click='deactivateDialog = false') Cancelar
              v-btn(
                :color="restaurantToDeactivate?.isActive ? 'warning' : 'success'"
                @click='toggleRestaurantStatus'
              ) {{ restaurantToDeactivate?.isActive ? 'Desactivar' : 'Reactivar' }}
</template>
<script>
import { format } from 'date-fns'
import { es } from 'date-fns/locale'
import { mapState } from 'vuex'
import LocationDialog from '@/components/admin/LocationDialog.vue'

export default {
  name: 'RestaurantsManager',
  components: {
    LocationDialog
  },
  data: () => ({
    loading: false,
    dialog: false,
    deactivateDialog: false,
    valid: false,
    search: '',
    brandFilter: null,
    statusFilter: null,
    logoFile: null,
    locationDialog: false,
    adminDialog: false,
    adminValid: false,
    creatingAdmin: false,
    selectedRestaurant: null,
    adminUser: {
      name: '',
      email: '',
      password: ''
    },
    emailRules: [
      v => !!v || 'El email es requerido',
      v => /.+@.+\..+/.test(v) || 'Email inválido'
    ],
    passwordRules: [
      v => !!v || 'La contraseña es requerida',
      v => v.length >= 8 || 'La contraseña debe tener al menos 8 caracteres'
    ],
    headers: [
      { text: 'Logo', value: 'logo', sortable: false },
      { text: 'Nombre', value: 'name' },
      { text: 'Dirección', value: 'location.address' },
      { text: 'Teléfono', value: 'phone' },
      { text: 'Marca', value: 'brand' },
      { text: 'Estado', value: 'isActive' },
      { text: 'Acciones', value: 'actions', sortable: false }
    ],
    editedItem: {
      name: '',
      address: '',
      phone: '',
      brand: null,
      logo: '',
      isActive: true,
      categories: [],
      description: '',
      location: {
        address: '',
        city: '',
        province: '',
        coordinates: [0, 0]
      }
    },
    restaurantToDeactivate: null,
    deactivationReason: '',
    weekDays: [
      'Domingo', 'Lunes', 'Martes', 'Miércoles',
      'Jueves', 'Viernes', 'Sábado'
    ],
    nameRules: [
      v => !!v || 'El nombre es requerido'
    ],
    phoneRules: [
      v => !v || /^\+?[\d\s-]+$/.test(v) || 'Teléfono inválido'
    ],
    logoRules: [
      v => !v || v.size < 5000000 || 'El logo debe ser menor a 5MB'
    ],
    statusOptions: [
      { text: 'Activos', value: true },
      { text: 'Inactivos', value: false }
    ],
    restaurantCategories: [],
    // Variables para gestión de usuarios
    usersDialog: false,
    userFormDialog: false,
    userFormValid: false,
    loadingUsers: false,
    savingUser: false,
    restaurantUsers: [],
    editedUser: {
      _id: null,
      name: '',
      email: '',
      phone: '',
      dni: '',
      role: null,
      password: '',
      active: true
    },
    defaultUser: {
      _id: null,
      name: '',
      email: '',
      phone: '',
      dni: '',
      role: null,
      password: '',
      active: true
    },
    userHeaders: [
      { text: 'Foto', value: 'photo', sortable: false },
      { text: 'Nombre', value: 'name' },
      { text: 'Email', value: 'email' },
      { text: 'Teléfono', value: 'phone' },
      { text: 'Rol', value: 'role', sortable: false },
      { text: 'Estado', value: 'active', sortable: false },
      { text: 'Acciones', value: 'actions', sortable: false }
    ]
  }),

  computed: {
    ...mapState({
      // En el módulo roles, la lista base está en systemRoles
      roles: state => state.roles.systemRoles
    }),
    restaurants() {
      return this.$store.state.restaurant.list
    },

    brands() {
      return this.$store.state.brands.list
    },

    filteredRestaurants() {
      return this.restaurants.filter(restaurant => {
        if (this.brandFilter && restaurant.brand !== this.brandFilter) {
          return false
        }
        if (this.statusFilter !== null && restaurant.isActive !== this.statusFilter) {
          return false
        }
        return true
      })
    },
    availableRoles() {
      // Asegurar array desde roles.systemRoles
      const list = Array.isArray(this.roles) ? this.roles : []

      // Filtrar rol propietario (owner)
      return list.filter(role => role?.name !== 'owner')
    }
  },

  methods: {
    openDialog(item = null) {
      this.dialog = true
      if (item) {
        // Clone the item to avoid direct mutation
        this.editedItem = JSON.parse(JSON.stringify(item))
        
        // Si no tiene location definido, crear una estructura base
        if (!this.editedItem.location) {
          this.editedItem.location = {
            address: '',
            city: '',
            province: '',
            coordinates: [0, 0]
          }
        }
        
        // Si no tiene coordinates, inicializar como array vacío
        if (!this.editedItem.location.coordinates) {
          this.editedItem.location.coordinates = [0, 0]
        }
      } else {
        this.resetForm()
      }
      
      // Dar tiempo al DOM para renderizar
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      })
    },
    resetForm() {
      this.editedItem = {
        name: '',
        address: '',
        phone: '',
        brand: null,
        logo: '',
        isActive: true,
        categories: [],
        description: '',
        location: {
          address: '',
          city: '',
          province: '',
          coordinates: [0, 0]
        }
      }
    },
    closeDialog() {
        this.dialog = false
        this.resetForm()
      },
    openAdminDialog(restaurant) {
      this.selectedRestaurant = restaurant
      this.adminUser = {
        name: '',
        email: '',
        password: ''
      }
      this.adminDialog = true
    },

    closeAdminDialog() {
      this.adminDialog = false
      this.selectedRestaurant = null
      this.$nextTick(() => {
        this.$refs.adminForm?.reset()
      })
    },

    async createAdminUser() {
      if (!this.$refs.adminForm.validate()) return

      this.creatingAdmin = true
      try {
        const role = this.roles.find(i => i.name === 'admin')
        await this.$store.dispatch('users/create', {
          ...this.adminUser,
          restaurant: this.selectedRestaurant._id,
          role: role._id
        })
        this.$toast.success('Usuario administrador creado exitosamente')
        this.closeAdminDialog()
      } catch (error) {
        this.$toast.error('Error al crear el usuario administrador')
      } finally {
        this.creatingAdmin = false
      }
    },
    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy', { locale: es })
    },

    async handleLogoUpload(file) {
      if (!file) return
      try {
        const formData = new FormData()
        formData.append('image', file)
        const response = await this.$store.dispatch('restaurant/uploadLogo', formData)
        this.editedItem.logo = response.url
      } catch (error) {
        this.$toast.error('Error al subir el logo')
      }
    },
    async handleCoverUpload(file) {
      if (!file) return
      try {
        const formData = new FormData()
        formData.append('image', file)
        const response = await this.$store.dispatch('restaurant/uploadCover', formData)
        this.editedItem.cover = response.url
      } catch (error) {
        this.$toast.error('Error al subir la imagen de portada')
      }
    },
    async save() {
      if (!this.$refs.form.validate()) return
      
      try {
        // Asegurarse de que los campos requeridos estén presentes
        if (!this.editedItem.name) {
          this.$toast.error('El nombre del restaurante es obligatorio')
          return
        }
        
        // Generar un urlSlug si no existe
        if (!this.editedItem.urlSlug) {
          this.editedItem.urlSlug = this.editedItem.name
            .toLowerCase()
            .replace(/[^\w\s]/gi, '')
            .replace(/\s+/g, '-')
        }
        
        // Asegurarse de que la ubicación esté bien formada
        if (!this.editedItem.location) {
          this.editedItem.location = {
            type: 'Point',
            coordinates: [0, 0],
            address: '',
            city: '',
            province: ''
          }
        } else if (!this.editedItem.location.type) {
          this.editedItem.location.type = 'Point'
        }
        
        // Asegurarse de que las coordenadas sean números
        if (this.editedItem.location && this.editedItem.location.coordinates) {
          this.editedItem.location.coordinates = [
            parseFloat(this.editedItem.location.coordinates[0]),
            parseFloat(this.editedItem.location.coordinates[1])
          ]
        }
        
        // Crear una copia del objeto para evitar errores de referencia
        const restaurantData = JSON.parse(JSON.stringify(this.editedItem))
        
        // Asegurarse de que las categorías sean un array de IDs
        if (restaurantData.categories && !Array.isArray(restaurantData.categories)) {
          restaurantData.categories = [restaurantData.categories]
        }
        
        // Asegurar que subscription.active sea true
        if (!restaurantData.subscription) {
          restaurantData.subscription = {
            active: true,
            plan: 'basic',
            startDate: new Date().toISOString()
          }
        } else if (restaurantData.subscription && restaurantData.subscription.active !== true) {
          restaurantData.subscription.active = true
        }
        
        console.log('Datos del restaurante a guardar:', restaurantData)
        
        if (restaurantData._id) {
          // Update existing restaurant
          await this.$store.dispatch('restaurant/update', restaurantData)
          this.$toast.success('Restaurante actualizado correctamente')
        } else {
          // Create new restaurant
          const newRestaurant = await this.$store.dispatch('restaurant/create', restaurantData)
          console.log('Restaurante creado:', newRestaurant)
          this.$toast.success('Restaurante creado correctamente')
        }
        
        // Refresh restaurant list
        await this.$store.dispatch('restaurant/fetchAllForAdmin')
        
        // Close dialog
        this.closeDialog()
      } catch (error) {
        console.error('Error al guardar restaurante:', error)
        this.$toast.error('Error al guardar restaurante: ' + (error.message || 'Error desconocido'))
      }
    },
    confirmDeactivate(restaurant) {
      this.restaurantToDeactivate = restaurant
      this.deactivationReason = ''
      this.deactivateDialog = true
    },

    confirmReactivate(restaurant) {
      this.restaurantToDeactivate = restaurant
      this.deactivateDialog = true
    },

    async toggleRestaurantStatus() {
      try {
        const isCurrentlyActive = this.restaurantToDeactivate.isActive
        const updateData = {
          ...this.restaurantToDeactivate,
          isActive: !isCurrentlyActive
        }
        
        // Si se está desactivando, agregar información de desactivación
        if (isCurrentlyActive) {
          updateData.deactivationConfig = {
            startTime: new Date(),
            reason: this.deactivationReason || 'Desactivado por administrador',
            isTemporary: false
          }
        } else {
          // Si se está reactivando, limpiar configuración de desactivación
          updateData.deactivationConfig = null
        }
        
        await this.$store.dispatch('restaurant/update', updateData)
        
        const action = isCurrentlyActive ? 'desactivado' : 'reactivado'
        this.$toast.success(`Restaurante ${action} correctamente`)
        
        this.deactivateDialog = false
        this.restaurantToDeactivate = null
        this.deactivationReason = ''
        
        // Recargar la lista
        await this.$store.dispatch('restaurant/fetchAllForAdmin')
      } catch (error) {
        console.error('Error al cambiar estado del restaurante:', error)
        this.$toast.error('Error al cambiar el estado del restaurante')
      }
    },
    getLocationForDialog() {
      if (!this.editedItem.location || !this.editedItem.location.coordinates) {
        return null;
      }
      
      return { 
        latitude: this.editedItem.location.coordinates[1], 
        longitude: this.editedItem.location.coordinates[0],
        maxDistance: this.editedItem.location.maxDistance || 5000 
      };
    },
    updateLocation(location) {
      // Convertir la respuesta del componente de ubicación al formato requerido por el modelo
      this.editedItem.location = {
        type: 'Point',
        coordinates: [location.longitude, location.latitude], // MongoDB usa [lng, lat]
        address: location.address,
        city: location.city,
        province: location.province,
        maxDistance: location.maxDistance
      }
    },

    // Métodos para gestión de usuarios
    async openUsersDialog(restaurant) {
      this.selectedRestaurant = restaurant
      this.usersDialog = true
      await this.loadRestaurantUsers(restaurant._id)
    },

    closeUsersDialog() {
      this.usersDialog = false
      this.selectedRestaurant = null
      this.restaurantUsers = []
    },

    async loadRestaurantUsers(restaurantId) {
      this.loadingUsers = true
      try {
        // Cargar usuarios del restaurante específico usando el store
        const users = await this.$store.dispatch('users/fetchByRestaurant', restaurantId)
        this.restaurantUsers = users
      } catch (error) {
        console.error('Error cargando usuarios:', error)
        this.$toast.error('Error al cargar usuarios del restaurante')
        this.restaurantUsers = []
      } finally {
        this.loadingUsers = false
      }
    },

    openUserForm(user = null) {
      if (user) {
        // Editar usuario existente
        this.editedUser = {
          ...user,
          role: user.role?._id || null,
          password: '' // No mostrar la contraseña actual
        }
      } else {
        // Nuevo usuario
        this.editedUser = { ...this.defaultUser }
      }
      this.userFormDialog = true
    },

    closeUserForm() {
      this.userFormDialog = false
      this.editedUser = { ...this.defaultUser }
      this.$nextTick(() => {
        if (this.$refs.userForm) {
          this.$refs.userForm.resetValidation()
        }
      })
    },

    async saveUser() {
      if (!this.$refs.userForm.validate()) return

      this.savingUser = true
      try {
        const userData = {
          ...this.editedUser,
          restaurant: this.selectedRestaurant._id
        }

        // Si no hay contraseña y es edición, no enviar el campo password
        if (userData._id && !userData.password) {
          delete userData.password
        }

        if (userData._id) {
          // Actualizar usuario existente
          await this.$store.dispatch('users/update', userData)
          this.$toast.success('Usuario actualizado correctamente')
        } else {
          // Crear nuevo usuario
          await this.$store.dispatch('users/create', userData)
          this.$toast.success('Usuario creado correctamente')
        }

        // Recargar la lista de usuarios
        await this.loadRestaurantUsers(this.selectedRestaurant._id)
        this.closeUserForm()
      } catch (error) {
        console.error('Error guardando usuario:', error)
        this.$toast.error('Error al guardar usuario: ' + (error.message || 'Error desconocido'))
      } finally {
        this.savingUser = false
      }
    },

    async toggleUserStatus(user) {
      try {
        if (user.active) {
          // Desactivar usuario
          await this.$store.dispatch('users/deactivate', user._id)
          this.$toast.success(`Usuario ${user.name} desactivado`)
        } else {
          // Reactivar usuario (actualizar con active: true)
          await this.$store.dispatch('users/update', {
            ...user,
            active: true
          })
          this.$toast.success(`Usuario ${user.name} reactivado`)
        }
        
        // Recargar la lista de usuarios
        await this.loadRestaurantUsers(this.selectedRestaurant._id)
      } catch (error) {
        console.error('Error cambiando estado del usuario:', error)
        this.$toast.error('Error al cambiar el estado del usuario')
      }
    },

    getRoleColor(roleName) {
      const roleColors = {
        'admin': 'primary',
        'manager': 'success',
        'employee': 'info',
        'waiter': 'warning',
        'chef': 'orange',
        'cashier': 'purple'
      }
      return roleColors[roleName] || 'grey'
    },
  },

  async created() {
    try {
      this.loading = true;
      await Promise.all([
        this.$store.dispatch('restaurant/fetchAllForAdmin'),
        this.$store.dispatch('brands/fetch'),
        // Cargar roles del sistema para poder asignar rol admin al restaurante
        this.$store.dispatch('roles/fetchSystemRoles'),
        this.$store.dispatch('restaurant/fetchCategories')
      ])
      this.restaurantCategories = this.$store.state.restaurant.categories
    } catch (error) {
      this.$toast.error('Error al cargar los datos')
    } finally {
      this.loading = false
    }
  }
}
</script>
